<template>
  <div class="avue-logo">
    <transition-group name="fade">
      <template v-if="!keyCollapse">
        <el-row key="1"
                class="avue-logo-title">
          <el-col :span="24">
            <img :src="platformData.logos||'/svg/logo.svg'"
                 class="avue-logo-image-2">
          </el-col>
          <el-col :span="24">
            <span class="logo-title">{{ `${platformData.title || $t('common.yinYeHealth')}（${$t('common.projectPort')}）` }}</span>
          </el-col>
        </el-row>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Logo',
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['keyCollapse', 'platformData'])
  }
}
</script>

<style scoped lang="scss">
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-active {
  transition: opacity 2.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.avue-logo {
  width: 280px;
  line-height: 60px;
  overflow: hidden;
  z-index: 1024;
  line-height: unset;
  background-color: #fff;
  border-radius: 0 100px 0 0;
  padding-bottom: 20px;
}

.avue-logo-image-1 {
  width: 45px;
  height: 45px;
  display: flex;
  margin: 20px auto;
}

.avue-logo-image-2 {
  width: 120px;
  height: 40px;
  display: flex;
  margin: 10px auto;
}

.logo-title {
  margin-top: 10px;
  font-size: 22px;
  color: #333;
  text-align: center;
  font-weight: 600;
  display: flex;
  justify-content: center;
}

.logo-remark {
  justify-content: center;
  margin-top: 16px;
  display: flex;
  font-size: 16px;
}

.tenant-select {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
